module.exports = __webpack_public_path__ + "static/media/Entypo.744ce600.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-vector-icons/Fonts/Entypo.ttf
// module id = 1255
// module chunks = 0